import React from "react";
import styles from "./Error.module.scss";

class Error extends React.Component{
    
    render(){
            const classes = []
            classes.push(styles.absolute_modal)
            if(this.props.show){
            classes.push(styles.activate)
            }else{
            classes.push(styles.close)
            }
          
            return(
                <div className={classes.join(" ")}>
                   <div className={styles.modal_title}>
                   <i style={{fontSize:"30px"}} class="fas fa-exclamation-circle"></i> <p style={{
                       fontWeight:"bolder",
                       fontSize:"25px",
                       marginLeft:"0.3rem"
                   }}>Error</p>
                   </div>
                   <div style={{
                       marginTop:"0.5rem",
                       
                   }}>
                    <p className="text-muted">{this.props.message}</p>
                   <button onClick={()=>{
                      this.props.onDiscard()
                   }} className={styles.discard}>Cancel</button>
                   </div>
                </div>
         )
        }
}

export default Error;